import { Brands } from '../../../config/brands';
import mainTheme from '../theme';

const theme = {
  ...mainTheme,
  name: Brands.MHI,
  COLORS: {
    ...mainTheme.COLORS,
    primary: '#7F9CA6',
    secondary: '#2D2D2D',
  },
};

export default theme;
